export default __webpack_public_path__ + "static/media/Poppins-Light.669df14a.woff2";